// src/components/relatorios/FiltrosRelatorios.js
import React, { useState } from 'react';

function FiltrosRelatorios({ filtros, onFiltrar }) {
  const [mesAno, setMesAno] = useState(filtros.mes_ano || '');

  const getMesAtual = () => {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    return `${ano}-${mes}`;
  };

  const handleMesAnterior = () => {
    const [ano, mes] = mesAno.split('-');
    const data = new Date(ano, mes - 1, 1);
    data.setMonth(data.getMonth() - 1);
    const novoMes = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
    setMesAno(novoMes);
    onFiltrar({ mes_ano: novoMes });
  };

  const handleProximoMes = () => {
    const [ano, mes] = mesAno.split('-');
    const data = new Date(ano, mes - 1, 1);
    data.setMonth(data.getMonth() + 1);
    const novoMes = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
    
    // Não permitir meses futuros
    const mesAtual = getMesAtual();
    if (novoMes <= mesAtual) {
      setMesAno(novoMes);
      onFiltrar({ mes_ano: novoMes });
    }
  };

  const handleMesAtual = () => {
    const mesAtual = getMesAtual();
    setMesAno(mesAtual);
    onFiltrar({ mes_ano: mesAtual });
  };

  const handleMudancaMes = (e) => {
    const novoMes = e.target.value;
    setMesAno(novoMes);
    onFiltrar({ mes_ano: novoMes });
  };

  const formatarMesExtenso = (mesAno) => {
    if (!mesAno) return '';
    const [ano, mes] = mesAno.split('-');
    const data = new Date(ano, mes - 1, 1);
    return data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="filtros-relatorios">
      <div className="filtros-container">
        <div className="filtro-mes">
          <label className="filtro-label">Período:</label>
          <div className="filtro-mes-controles">
            <button 
              className="btn-mes-nav"
              onClick={handleMesAnterior}
              title="Mês Anterior"
            >
              ◀
            </button>
            
            <input 
              type="month"
              value={mesAno}
              onChange={handleMudancaMes}
              max={getMesAtual()}
              className="input-mes"
            />
            
            <button 
              className="btn-mes-nav"
              onClick={handleProximoMes}
              disabled={mesAno >= getMesAtual()}
              title="Próximo Mês"
            >
              ▶
            </button>
            
            <button 
              className="btn-mes-atual"
              onClick={handleMesAtual}
            >
              Mês Atual
            </button>
          </div>
        </div>

        <div className="filtro-mes-extenso">
          📅 {formatarMesExtenso(mesAno)}
        </div>
      </div>
    </div>
  );
}

export default FiltrosRelatorios;
